import Vue from 'vue';

window.Vue = Vue;
window.axios = require('axios');

Vue.component('MainComponent', require('../templates/MainComponent.vue').default);

const app = new Vue({
    el: '#app_local_maintenance_alerts'
});